import * as HttpService from './http.service';
import * as URL from './url.service';

export const createImpersonationService = (body) => HttpService.postWithAuth(URL.CREATE_IMPERSONATION_URL, body);

export const updateImpersonationService = () => HttpService.putWithAuth(URL.CREATE_IMPERSONATION_URL, {});

export const revokeImpersonationService = () => HttpService.postWithAuth(URL.REVOKE_IMPERSONATION_URL, {});
